import { render, staticRenderFns } from "./addorg.vue?vue&type=template&id=20602f18&scoped=true&"
import script from "./addorg.vue?vue&type=script&lang=js&"
export * from "./addorg.vue?vue&type=script&lang=js&"
import style0 from "./addorg.vue?vue&type=style&index=0&id=20602f18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20602f18",
  null
  
)

export default component.exports